import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useParams} from "react-router";
import statesApi from "../../../services/statesApi";
import typePropertyApi from "../../../services/typePropertyApi";
import userApi from "../../../services/userApi";
import FormLayout from "../../../componets/layout/FormLayout";
import Input from "../../../componets/inputs/Input";
import ViaCepService from "../../../services/viaCepApi";
import InputSelect from "../../../componets/inputs/inputSelect";
import cityApi from "../../../services/cityApi";
import InputCurrency from "../../../componets/inputs/inputCurrency";
import propertyApi from "../../../services/propertyApi";
import ImageButton from "../../../componets/button/ImageButton";
import { RiImageAddFill } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
export default function FormProprieties() {
    const defaltValues = {
        id: '',
        tipo_id: '',
        state_id: '',
        city_id: '',
        descricao: '',
        cep: '',
        endereco: '',
        quadra: '',
        lote: '',
        numero: '',
        bairro: '',
        complemento: '',
        area_construida: '',
        area_terreno: '',
        valor: '',
        images: [],
        images_remove: [],
    }
    const navigate = useNavigate();
    const [state, setState]: any = useState(defaltValues);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [stateOptions, setStateOptions]: any = useState([])
    const [typePropertiesOptions, setTypePropertiesOptions]: any = useState([])
    const [ibgeCity, setIbgeCity] = useState();
    const [cityOptions, setCityOptions]: any = useState();
    const [loadingDataCity, setLoadingDataCity] = useState(false);
    const [loadingDataState, setLoadingDataState] = useState(false);
    const [imagesScreen, setImagesScreen]: any = useState([]);
    const [imageRemove, setImageRemove] = useState([]);

    const cepSrv = new ViaCepService();
    const getDatas = async () => {
        const [statData, typePropertyData, propertyData] = await Promise.all([
            statesApi.listAll(),
            typePropertyApi.listAll(),
            params.id ? propertyApi.one(params.id): ''
        ]);
        if (!statData.isError){
            setStateOptions(statData.data.map((dt:any) => {return {value: dt.id, label: dt.description, code: dt.uf}}))
        }
        if (!typePropertyData.isError){
            setTypePropertiesOptions(typePropertyData.data.map((dt:any) => {return {value: dt.id, label: dt.descricao}}))
        }
        if (params.id){
            if (typeof propertyData !== "string" && !propertyData?.isError){
                setState(propertyData.data)
                getCity(propertyData.data.state_id)
                setImagesScreen(propertyData.data.images)

            }

        }

        setLoading(false)
    }

    useEffect(() => {
        getDatas()
    }, [])

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };

    const searchCep = () => {
        if (state.cep.length === 8){
            cepSrv.consultaCep(state.cep).then((cepResponse: any) =>{
                if (!cepResponse.data.erro){
                    const stateCep = stateOptions.filter((st: any) => st.code === cepResponse.data.uf);
                    const newState = {...state}
                    newState.state_id = stateCep[0].value
                    newState.bairro = cepResponse.data.bairro;
                    newState.endereco = cepResponse.data.logradouro;
                    setIbgeCity(cepResponse.data.ibge)
                    setState(newState)
                }
            });
        }
    }

    useEffect(() => {
        if (state.state_id){
            getCity(parseInt(state.state_id), ibgeCity)
        }
    }, [ibgeCity])

    const onSelectState = (value: any) => {
        setState({...state, ['state_id']: value});
        getCity(value)
    }

    const getCity = async (idState: number, searchCep?: string) => {
        setLoadingDataCity(true)
        const {data, isError} = await cityApi.getCity(idState);
        if (!isError){
            const dataSelect = data.map((dt:any) => {return {value: dt.id, label: dt.description}});
            if (searchCep){
                const city = data.filter((ds: any) => ds.iso === searchCep);
                const newState = {...state}
                newState.city_id = city[0].id;
                setState(newState)
            }
            setCityOptions(dataSelect)
        }
        setLoadingDataCity(false)
    }

    function convertFileToBase64(file: any, callback: any, originalName?: boolean) {

        const reader = new FileReader();
        reader.readAsDataURL(file);
        if (originalName){
            reader.onloadend = () => callback({
                file: reader.result,
                original_name: file.name
            });
        }else{
            reader.onloadend = () => callback(reader.result);
        }

    }

    const onSelectImages = async (data: any) => {
        const newState = {...state}
        let imagesData: any[] = []
        let imagesbase64: any[] = []
        imagesData = data.map((file: any) => {
            return(
                {
                    url_path: URL.createObjectURL(file),
                    original_name: file.name
                }
            )
        })
        if (imagesScreen.length){
            imagesData = imagesData.concat(imagesScreen);
        }
        data.map((img: any) => {
            convertFileToBase64(img, (str: any) => imagesbase64.push({
                url_path: str,
                original_name: img.name
            }))
        })

        if (newState.images.length){
            imagesbase64 = newState.images.concat(imagesbase64)
        }
        newState.images = imagesbase64
        setState(newState)
        setImagesScreen(imagesData)
    }

    const onRemoveImg = async (image: any) => {
        if (image.id){
            const newImageRemove = [...imageRemove];
            // @ts-ignore
            newImageRemove.push(image)
            setImageRemove(newImageRemove)
            const newState = {...state}
            if (newState.images_remove){
                newState.images_remove.push(image);
            }else{
                newState.images_remove = [image];
            }
            setState(newState);
        }
        const newImageScreen = [...imagesScreen];
        setImagesScreen(newImageScreen.filter((ips: any, indexIps: number) => image.original_name != ips.original_name))
    }

    return(
        <FormLayout
            title={'Cadastro de imóveis'}
            urlReturn={'/imoveis/lista'}
            state={state}
            setState={setState}
            apiData={propertyApi}
            defaltValues={defaltValues}
        >
            {
                loading ?
                    <span className="flex items-center justify-center h-7">
                        <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </span>
                    :
                    <div className={'flex md:flex-row w-full md:p-4 xs:p-1'}>
                        <div className={'w-full grid'}>
                            <div className="grid grid-cols-12 gap-5">
                                <Input
                                    required
                                    className={'md:col-span-2 xs:col-span-12'}
                                    label={'CEP'}
                                    mask={'CEP'}
                                    name={'cep'}
                                    value={state.cep}
                                    setValue={v => handleChange(v, 'cep')}
                                    onBlur={() => searchCep()}
                                />
                                <Input
                                    required
                                    label={'Endereço'}
                                    value={state.endereco}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'endereco')}
                                />
                                <Input
                                    label={'Qd.'}
                                    value={state.quadra}
                                    className={'md:col-span-1 xs:col-span-6'}
                                    setValue={(v) => handleChange(v, 'quadra')}
                                />
                                <Input
                                    label={'Lt.'}
                                    value={state.lote}
                                    className={'md:col-span-1 xs:col-span-6'}
                                    setValue={(v) => handleChange(v, 'lote')}
                                />
                                <Input
                                    label={'Complemento'}
                                    value={state.complemento}
                                    className={'md:col-span-5 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'complemento')}
                                />
                                <Input
                                    required
                                    label={'Bairro'}
                                    value={state.bairro}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'bairro')}
                                />
                                <InputSelect
                                    required
                                    loading={loadingDataState}
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={state.state_id}
                                    label={'Estado'}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    options={stateOptions}
                                    onChangeSelect={(e: any) => onSelectState(e.value)}
                                    placeholder={'Estado'}
                                />
                                <InputSelect
                                    required
                                    loading={loadingDataCity}
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={state.city_id}
                                    label={'Cidade'}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    options={cityOptions}
                                    onChangeSelect={(e: any) => handleChange(e.value, 'city_id')}
                                    placeholder={'Cidade'}
                                />
                                <InputSelect
                                    required
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={state.tipo_id}
                                    label={'Tipo do imóvel'}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    options={typePropertiesOptions}
                                    onChangeSelect={(e: any) => handleChange(e.value, 'tipo_id')}
                                    placeholder={'Tipo de imóvel'}
                                />
                                <Input
                                    label={'descrição'}
                                    value={state.descricao}
                                    className={'md:col-span-5 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'descricao')}
                                />
                                <Input
                                    label={'Área construida'}
                                    value={state.area_construida}
                                    className={'md:col-span-2 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'area_construida')}
                                />
                                <Input
                                    label={'Área terreno'}
                                    value={state.area_terreno}
                                    className={'md:col-span-2 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'area_terreno')}
                                />
                                <InputCurrency
                                    label={'Valor'}
                                    value={state.valor}
                                    className={'md:col-span-2 xs:col-span-12'}
                                    onChange={
                                        (value: any, name: any) =>handleChange(value, 'valor')
                                    }
                                />
                            </div>
                            <div className={'md:col-span-6 xs:col-span-12 flex gap-4 items-center content-center md:pt-5 content-center text-[25px] text-system-primary'}>
                                <ImageButton
                                    onSelect={(e: any) => onSelectImages(e)}
                                    id={'images-properties'}
                                    icon={<RiImageAddFill/>}
                                    accept={'image/*'}
                                />

                            </div>
                            {

                                imagesScreen.length ?
                                    <div className={'flex flex-wrap gap-3 mt-5'}>
                                        {
                                            imagesScreen.map((image: any, index: number) => {
                                                return  <div className={'border-2 border-border p-1 rounded-md relative'}>
                                                    <button type={'button'} onClick={() => onRemoveImg(image)} className={'w-[20px] h-[20px] absolute text-system-primary top-1  rounded-full justify-center'}>
                                                        <IoClose/>
                                                    </button>
                                                    <img className={'w-[100px] h-[100px]'} src={image.url_path ? image.url_path : image.image_path}/>
                                                </div>
                                            })
                                        }

                                    </div>
                                    :''
                            }
                        </div>

                    </div>
            }

        </FormLayout>
    )


}